module.exports = __webpack_public_path__ + "media/flags/eu-f02d6a78.gif";